import { BarceloComponent } from "components-utils";

const GenericComponents = {
  label: BarceloComponent({
    selector: ".c-label",
    path: "barcelo/generic/label/js/label",
  }),

  textImage: BarceloComponent({
    selector: ".c-textimage, .textimage",
    path: "barcelo/generic/textimage/js/textimage",
  }),

  cta: BarceloComponent({
    selector: ".c-cta",
    path: "barcelo/generic/cta/js/c-cta",
  }),

  socialSharing: BarceloComponent({
    selector: ".c-social-sharing",
    path: "barcelo/generic/social-sharing/js/social-sharing",
  }),

  filePicker: BarceloComponent({
    selector: ".barcelo-filePicker",
    path: "barcelo/generic/filePicker/js/filePicker",
  }),

  rp1Offer: BarceloComponent({
    selector: ".rp1Offer",
    path: "barcelo/generic/rp1Offer/js/rp1Offer",
    enableObserver: true,
  }),

  homeCampaign: BarceloComponent({
    selector: ".home-campaign",
    path: "barcelo/generic/homeCampaign/js/homeCampaign",
    enableObserver: true,
    ignoreViewport: true,
  }),

  icon: BarceloComponent({
    selector: ".c-icon",
    path: "barcelo/generic/icon/js/c-icon",
  }),

  progressBar: BarceloComponent({
    selector: ".c-progress-bar",
    path: "barcelo/generic/progress-bar/js/progress-bar",
  }),

  tooltip: BarceloComponent({
    selector: ".tooltip-JS",
    path: "barcelo/generic/tooltip/js/tooltip",
  }),

  rteTooltip: BarceloComponent({
    selector: ".bhg-tooltip--hidden, .bhg-tooltip",
    path: "barcelo/generic/tooltip/js/rte-tooltip",
  }),

  cmpTabs: BarceloComponent({
    selector: ".cmp-tabs-dl-id, .cmp-tabs, .cmp-tabs__tablist, .cmp-tabs__tabpanel, .empty-option-tabs-JS",
    path: "barcelo/generic/cmp-tabs/js/cmp-tabs",
  }),

  panorama: BarceloComponent({
    selector: "[data-image-360='true']",
    path: "barcelo/generic/panorama/js/panorama",
  }),

  flipcard: BarceloComponent({
    selector: ".c-flip-card-JS",
    path: "barcelo/generic/flip-card/js/flip-card",
    enableObserver: true,
    ignoreViewport: true,
  }),

  hotelPageAnalytics: BarceloComponent({
    selector: "[data-template='hotel'], [data-template='resort'], [data-template='hotel-royal'], [data-template='brb-hotel']",
    path: "barcelo/page/hotel-page/js/analytics",
    ignoreViewport: true,
  }),
};

export default GenericComponents;
